import { ActionCard } from '@components/display/cards';
import { DefaultBadge } from '@levelSystem/components/badges';
import { Chip, Typography } from '@mui/material';
import { format } from 'date-fns';

export const LoadingActionCard = () => (
    <ActionCard
        loading
        img={
            <DefaultBadge
                className="!size-24"
                level={1}
                badgeCoreProps={{
                    className: '!size-12',
                }}
            />
        }
        typographyElements={[
            <Typography fontWeight={500}>Level 1</Typography>,
            <Typography color="neutral-600" fontSize={12} fontWeight={500}>
                {format(new Date(), 'dd/MM/yyyy')}
            </Typography>,
        ]}
        chips={[
            <Chip
                className="blue-gradient"
                label={
                    <Typography fontSize={12} fontWeight={500} color="white.main">
                        Sample Badge
                    </Typography>
                }
                size="small"
            />,
        ]}
        className="min-w-0 w-auto flex-[0_0_calc(25%-32px)]"
    />
);
